import React from 'react';
import { Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { Carousel } from '@one-thd/sui-carousel';

const LoaderListPod = () => {
  return (
    <Skeleton>
      <SkeletonBlock aspect="wide" />
      <SkeletonLine numberOfLines={5} />
    </Skeleton>
  );
};

const LoaderListWrapper = () => {
  return (
    <Carousel
      slidesPerView={1}
      slidesPerGroup={1}
    >
      {new Array(5).fill('').map((value, i) => (
        <LoaderListPod key={`row-${i}`} />
      ))}
    </Carousel>
  );
};

const ListLoader = () => {
  return LoaderListWrapper();
};

export default ListLoader;
